
var id = "Kpi";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"Kpi\"><defs><style type=\"text/css\"></style></defs><path d=\"M281.366128 680.747716a23.747013 23.747013 0 0 0-23.027407 23.747013 23.027407 23.027407 0 0 0 23.027407 23.027407h464.14617a23.027407 23.027407 0 0 0 23.027407-23.027407 23.027407 23.027407 0 0 0-23.027407-23.747013z m503.724526-215.881939V287.842586a35.980323 35.980323 0 0 0 0-8.635277v-7.915672H615.263528a23.747013 23.747013 0 0 0 0 46.774421h84.193956L532.508784 474.220661 417.37175 359.803233a25.186226 25.186226 0 0 0-16.550949-6.476459 23.027407 23.027407 0 0 0-16.550949 6.476459L251.862263 490.771609a23.747013 23.747013 0 1 0 33.101897 33.101898l115.856641-115.856641 115.137035 115.856641a25.186226 25.186226 0 0 0 16.550948 6.476458 23.027407 23.027407 0 0 0 16.550949-6.476458l182.780042-182.780042v123.772312a23.747013 23.747013 0 0 0 23.747013 23.027406 23.027407 23.027407 0 0 0 23.027407-23.027406z\" p-id=\"3459\" /><path d=\"M857.0513 1024H166.229093a100.744905 100.744905 0 0 1-100.744905-100.744905V100.744905A100.744905 100.744905 0 0 1 166.229093 0H857.0513a100.744905 100.744905 0 0 1 100.744905 100.744905v822.51019a100.744905 100.744905 0 0 1-100.744905 100.744905zM166.229093 57.568517a43.176388 43.176388 0 0 0-43.176387 43.176388v822.51019a43.176388 43.176388 0 0 0 43.176387 43.176388H857.0513a43.176388 43.176388 0 0 0 43.176388-43.176388V100.744905a43.176388 43.176388 0 0 0-43.176388-43.176388z\" p-id=\"3460\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
